export default "__VITE_ASSET__Bz8_OCN1__"